import React, { ReactElement, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Loading from 'src/components/templates/Loading'
import { AuthContext } from 'src/context/auth.context'
import useAuthorizationGuidance from 'src/hooks/useAuthorizationGuidance'
import Path from 'src/routes/path'
import { postAuth } from 'src/slices/auth/authSlice'
import { useAppDispatch, useAppSelector } from 'src/store'

const Root: React.FC = (): ReactElement => {
  const authContext = useContext(AuthContext)
  const navigate = useNavigate()
  const { status, currentAuthorization } = useAppSelector((state) => state.auth)
  const dispatch = useAppDispatch()
  const guidance = useAuthorizationGuidance()

  useEffect(() => {
    if (status === 'idle') {
      dispatch(postAuth())
    }
    if (currentAuthorization) {
      navigate(
        Path.storeSalesReportSummaries(currentAuthorization.organization.code)
      )
    }
  }, [navigate, status, currentAuthorization, dispatch, authContext])

  if (guidance) {
    return guidance
  }

  return <Loading />
}

export default Root
